__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "shell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/animations", "18.2.14", () => (() => (__webpack_require__(/*! ./node_modules/@angular/animations/fesm2022/animations.mjs */ 47172))), 1);
			register("@angular/cdk", "18.2.14", () => (() => (__webpack_require__(/*! ./node_modules/@angular/cdk/fesm2022/cdk.mjs */ 31398))), 1);
			register("@angular/common", "18.2.14", () => (() => (__webpack_require__(/*! ./node_modules/@angular/common/fesm2022/common.mjs */ 60316))), 1);
			register("@angular/core", "18.2.14", () => (() => (__webpack_require__(/*! ./node_modules/@angular/core/fesm2022/core.mjs */ 37580))), 1);
			register("@angular/forms", "18.2.14", () => (() => (__webpack_require__(/*! ./node_modules/@angular/forms/fesm2022/forms.mjs */ 34456))), 1);
			register("@angular/platform-browser", "18.2.14", () => (() => (__webpack_require__(/*! ./node_modules/@angular/platform-browser/fesm2022/platform-browser.mjs */ 80436))), 1);
			register("@angular/router", "18.2.14", () => (() => (__webpack_require__(/*! ./node_modules/@angular/router/fesm2022/router.mjs */ 95072))), 1);
			register("@auth0/angular-jwt", "5.2.0", () => (() => (__webpack_require__(/*! ./node_modules/@auth0/angular-jwt/fesm2020/auth0-angular-jwt.mjs */ 92389))), 1);
			register("@ngx-translate/core", "14.0.0", () => (() => (__webpack_require__(/*! ./node_modules/@ngx-translate/core/fesm2020/ngx-translate-core.mjs */ 597))), 1);
			register("@ngxs/router-plugin", "3.8.2", () => (() => (__webpack_require__(/*! ./node_modules/@ngxs/router-plugin/fesm2015/ngxs-router-plugin.js */ 17039))), 1);
			register("@ngxs/store", "18.1.6", () => (() => (__webpack_require__(/*! ./node_modules/@ngxs/store/fesm2022/ngxs-store.mjs */ 68267))), 1);
			register("lodash-es", "4.17.21", () => (() => (__webpack_require__(/*! ./node_modules/lodash-es/lodash.js */ 50381))), 1);
			register("ng2-file-upload", "1.4.0", () => (() => (__webpack_require__(/*! ./node_modules/ng2-file-upload/fesm2015/ng2-file-upload.js */ 78553))), 1);
			register("rxjs", "7.8.2", () => (() => (__webpack_require__(/*! ./node_modules/rxjs/dist/esm/index.js */ 80845))), 1);
			register("shared-states", "18.0.17", () => (() => (__webpack_require__(/*! ./node_modules/shared-states/fesm2022/shared-states.mjs */ 31455))), 1);
			register("tslib", "2.8.1", () => (() => (__webpack_require__(/*! ./node_modules/tslib/tslib.es6.mjs */ 24398))), 1);
			register("zone.js", "0.14.10", () => (() => (__webpack_require__(/*! ./node_modules/zone.js/fesm2015/zone.js */ 74124))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};